module.exports = __webpack_public_path__ + "img/photo-0056.1db266bb.jpg";